

































import _ from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import rest from "@/rest";
// interfaces
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { TrainingUserVm } from "@/interfaces/TrainingUserVm";

// Server side search in the users of an organization. multiple: v-model is a list of users, otherwise a single user (or null).
@Component
export default class TrainingUserSelect extends Vue {
  @Prop({ required: true, type: Number }) readonly orgId!: number;
  @Prop({ type: String, default: "Anwender" }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly multiple!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "" }) readonly hint!: string;
  @Prop({ default: null }) readonly value!: TrainingUserVm | TrainingUserVm[] | null;

  selected: TrainingUserVm | TrainingUserVm[] | null = null;
  suggestions: TrainingUserVm[] = [];
  search = "";
  loading = false;

  readonly debouncedLoad = _.debounce(() => this.loadSuggestions(), 300);

  // The selected users have to stay in the items, otherwise the chips lose their text
  get items(): TrainingUserVm[] {
    const selected = this.selected ? (Array.isArray(this.selected) ? this.selected : [this.selected]) : [];
    return _.uniqBy([...selected, ...this.suggestions], u => u.id);
  }

  @Watch("value", { immediate: true })
  onValueChanged(value: TrainingUserVm | TrainingUserVm[] | null): void {
    this.selected = value;
  }

  @Watch("search")
  onSearchChanged(search: string | null): void {
    // After selecting a single user the search text equals its name: no need to search again
    if (!this.multiple && this.selected && !Array.isArray(this.selected) && this.selected.fullName === search) return;
    this.debouncedLoad();
  }

  mounted(): void {
    this.loadSuggestions();
  }

  async loadSuggestions(): Promise<void> {
    this.loading = true;
    try {
      const params: ParamDictionary = { dictionary: {} };
      params.dictionary!["OrgId"] = this.orgId.toString();
      params.dictionary!["Search"] = this.search || "";
      // On errors the rest wrapper shows the message and returns undefined
      this.suggestions = (await rest.url("trainingLead/searchUsers").post(params)) ?? [];
    } finally {
      this.loading = false;
    }
  }

  onChange(value: TrainingUserVm | TrainingUserVm[] | null): void {
    this.search = "";
    this.$emit("input", value);
  }
}
